import { SET_IS_UI_MODAL_OPEN } from '../types'

export const setIsUiModalOpen = (modalName: string, status: boolean) => ({
  type: SET_IS_UI_MODAL_OPEN,
  payload: {
    name: modalName,
    status,
  },
})
